import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import {
  mapsReadyGuard,
  provideZMaps,
  withConfig,
  withLoader,
} from '@gozetta/z-maps';
import {
  provideHttpClient,
  withInterceptors,
  withRequestsMadeViaParent,
} from '@angular/common/http';
import { withLiveMap } from '@gozetta/z-maps/vehicles';
import { MapEtaComponent } from '@gozetta/z-maps/eta';
import { environment } from '@envs/environment';
import { MapLoaderService } from '@shared/services/map-loader.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { liveMapBoundsResolver } from './live-map-bounds.resolver';
import { skipLoaderInterceptor } from '@core/components/loader/loader.interceptor';
import { LiveMapService } from './services/live-map.service';
import { permissionGuard } from '@core/guards';

const MAPS_ID = '6a2150d7d0e6b1dc';

export const liveMapRoutes: Routes = [
  {
    path: 'live-map',
    loadComponent: () =>
      import('./live-map.component').then(m => m.LiveMapComponent),
    providers: [
      provideZMaps(
        withLoader(
          () =>
            firstValueFrom(
              inject(MapLoaderService)
                .getGoogleAPIConfigurations()
                .pipe(map(c => c.googleKey))
            ),
          ['maps', 'marker', 'places', 'geometry'],
          'lazy'
        ),
        withConfig({
          mapId: MAPS_ID,
          restriction: {
            strictBounds: true, // Strict to world view Map
            latLngBounds: {
              north: 85, // Upper latitude limit
              south: -85, // Lower latitude limit
              west: -179.999, // Left longitude limit (slightly adjusted to prevent wrapping)
              east: 179.999, // Right longitude limit (slightly adjusted to prevent wrapping)
            },
          },
        })
      ),
      withLiveMap({
        apiUrl: environment.dispatchUrl,
        firebase: { collections: environment.liveMapFirebaseCollectionName },
        pollingInterval: 120_000,
      }),
      provideHttpClient(
        withRequestsMadeViaParent(),
        withInterceptors([skipLoaderInterceptor])
      ),
      LiveMapService,
    ],
    resolve: { initialClusters: liveMapBoundsResolver },
    canActivate: [mapsReadyGuard, permissionGuard('CustomerLiveMapView')],
    children: [
      {
        path: 'eta',
        component: MapEtaComponent,
      },
      {
        path: 'vehicles',
        loadChildren: () =>
          import('@gozetta/z-maps/vehicles').then(m => m.VEHICLE_ROUTES),
      },
    ],
  },
];
